import { Typography } from "@mui/material";
import styled from "styled-components";

export const ContainerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 400px;
  padding: 24px 0;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: 1px;
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  overflow-y: auto;
  width: 400px;
  background: #ffffff;
  height: calc(100vh - 210px);
`;

export const Container = styled.div<{
  colorSelected?: boolean | null;
  cadHeight: boolean;
}>`
  display: flex;
  width: 100%;
  flex-direction: column;
  background: ${({ colorSelected }) => (colorSelected ? "#ffefea" : "#fafafa")};
  :hover {
    background: #ffffff;
  }
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  min-height: ${({ cadHeight }) => (cadHeight ? "190px" : "150px")};
`;

export const CardContent = styled.button`
  display: flex;
  border: none;
  align-items: flex-start;
  cursor: pointer;
  justify-content: space-between;
  background: transparent;
  flex-direction: column;
  padding: 12px 16px;
`;

export const NameCard = styled(Typography)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  text-align: left;
  font-weight: 500 !important;
`;

export const NameAdress = styled(Typography)`
  display: flex;
  padding-top: 5px;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const NameLocale = styled(Typography)`
  display: flex;
  padding-top: 4px;
  padding-left: 25px;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContainerTimer = styled.div`
  display: flex;
  height: 100%;
  min-width: 150px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 3px;
`;

export const ContainerStatus = styled.div<{ colorTheme?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 3px 6px;
  margin-left: 5px;
  height: 24px;
  width: 145px;
  gap: 4px;

  border: 1px solid
    ${({ theme, colorTheme }) =>
      colorTheme === "primary"
        ? theme.palette.text.primary
        : theme.palette.warning.main};
  span {
    line-height: 0;
  }

  svg {
    color: ${({ theme }) => theme.palette.warning.main};
  }
`;

export const ButtonAcceptOrder = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 90px;
  background: #d33100;
  max-width: 250px;
  height: 42px;
  border-radius: 21px;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff;
  white-space: nowrap;
  align-self: center;
`;

export const ContainerColumn = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
`;

export const ContainerRow = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
`;

export const ContentRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const ScheduledDeliveryOrder = styled.div`
  background-color: #fbefeb;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
  margin: 8px 0;
  padding: 8px 16px;
  border-radius: 99px;
`;
